/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import { paginationStyles } from "@insite/content-library/Widgets/ProductList/ProductListPagination";
import { screen } from "@monsma/XDL/Helpers";
import { css } from "styled-components";

paginationStyles.pagination = {
    cssOverrides: {
        pagination: css`
            &&& {
                margin: 0;
                justify-content: space-between !important;
                /* The original pagination code have important so I've added this to apply my change */

                ${screen("lt", "md")} {
                    justify-content: center;
                }

                ${screen("gte", "sm")} {
                    nav ul li {
                        &:first-child {
                            button {
                                padding-left: 0;
                            }
                        }

                        &:last-child {
                            button {
                                padding-right: 0;
                            }
                        }
                    }
                }
            }
        `,
    },
};
